import styled, { css, keyframes } from 'styled-components';
import { targetable } from '../Card/styled';
import { WIDE_SCREEN } from '../ActiveGame/styled';

export const Label = styled.div`
  padding: 8px 12px 0;
  height: 24px;
  box-sizing: border-box;
  font-size: 11px;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: var(--muted);
`;

/** One scrolling row when the phone is upright; wrapped rows in the side panel when it is turned. */
export const Tray = styled.div`
  --card-w: 64px;
  display: flex;
  gap: 6px;
  padding: 8px 12px 12px;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  border-radius: 8px;
  ${props => props.$lit && targetable}

  @media (orientation: landscape) {
    --card-w: 58px;
    flex-wrap: wrap;
    overflow-x: visible;
  }

  @media ${WIDE_SCREEN} {
    --card-w: clamp(72px, 6.5vw, 110px);
    gap: 8px;
  }
`;

const glow = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(255, 209, 102, 0); }
  15% { box-shadow: 0 0 0 3px rgba(255, 209, 102, .95), 0 0 18px 4px rgba(255, 209, 102, .7); }
  100% { box-shadow: 0 0 0 2px rgba(255, 209, 102, .8), 0 0 10px 2px rgba(255, 209, 102, .35); }
`;

/** A hand card; one that just came in glows, with a "New" tag, for a few seconds. */
export const NewMark = styled.span`
  position: relative;
  display: block;
  border-radius: calc(var(--card-w) * .051);

  ${({ $new }) => $new && css`
    animation: ${glow} .6s ease-out both;

    &::after {
      content: 'New';
      position: absolute;
      top: 2px;
      right: 2px;
      padding: 1px 6px;
      border-radius: 8px;
      background: #ffd166;
      color: #1b1b1b;
      font-size: 10px;
      font-weight: 800;
      letter-spacing: .04em;
      text-transform: uppercase;
      pointer-events: none;
    }
  `}
`;

const shake = keyframes`
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-6px) rotate(-2deg); }
  40% { transform: translateX(5px) rotate(1.5deg); }
  60% { transform: translateX(-4px) rotate(-1deg); }
  80% { transform: translateX(2px); }
`;

/** The card shaking its head. */
export const Shake = styled.span`
  display: block;
  animation: ${({ $on }) => ($on ? css`${shake} .45s ease-in-out` : 'none')};
`;

/** Why the card you just tried to drag can't be played, in place of the hand's label (the same height, so nothing moves). */
export const RefusalNote = styled.p`
  margin: 0;
  padding: 6px 12px 0;
  height: 24px;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
  font-weight: 600;
  color: #ffd166;
  animation: ${shake} .45s ease-in-out;
`;
